import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabaseClient";
import { useLeagueSeasonStore } from "@/state/useLeagueSeasonStore";

export function useIncomingTeamsBadge(leagueIds: string[]) {
  const season = useLeagueSeasonStore((s) => s.currentSeason);
  return useQuery({
    queryKey: ["incomingTeamsBadge", season, leagueIds],
    enabled: !!season && leagueIds.length > 0,
    staleTime: 60_000,
    queryFn: async (): Promise<{ count: number }> => {
      // Only relevant while a transition INTO the selected season is in flight.
      const { data: tr, error: trErr } = await supabase
        .from("season_transitions")
        .select("id,to_season,status")
        .eq("to_season", season)
        .neq("status", "activated")
        .order("initiated_at", { ascending: false })
        .limit(1)
        .maybeSingle();
      if (trErr) throw new Error(`useIncomingTeamsBadge(transition): ${trErr.message}`);
      if (!tr) return { count: 0 };
      const { count, error } = await supabase
        .from("season_transition_team_moves")
        .select("team_id", { count: "exact", head: true })
        .eq("transition_id", tr.id)
        .in("to_league_id", leagueIds)
        .is("to_group_id", null)
        .in("movement_type", ["promotion", "relegation", "admitted"]);
      if (error) throw new Error(`useIncomingTeamsBadge: ${error.message}`);
      return { count: count ?? 0 };
    },
  });
}
